import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import OrderCTA from '../components/OrderCTA';

import aboutBg from '../assets/aboutbg.webp';

const Contact = () => {
    return (
        <div>
            <section
                className="relative text-white py-40 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-cover bg-bottom min-h-[30vh] flex flex-col justify-center"
                style={{ backgroundImage: `url(${aboutBg})` }}
            >
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold mb-6 font-serif text-secondary">Contact Us</h1>
                    <p className="text-xl md:text-2xl text-green-50 max-w-3xl mx-auto">
                        We'd love to hear from you. Let's start your order.
                    </p>
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

                    {/* Contact Info */}
                    <div className="bg-white p-8 rounded-xl shadow-lg">
                        <h2 className="text-2xl font-bold mb-8 text-primary">Get in Touch</h2>
                        <div className="space-y-8">
                            <div className="flex items-start gap-4">
                                <div className="bg-green-100 p-3 rounded-full text-primary">
                                    <MapPin size={24} />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-dark">Visit Us</h3>
                                    <p className="text-gray-600">Plot A/6 Sector 11-G New Karachi, Pakistan</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="bg-green-100 p-3 rounded-full text-primary">
                                    <Mail size={24} />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-dark">Email Us</h3>
                                    <p className="text-gray-600">info@threadneedlevalley.com</p>
                                    <p className="text-sm text-gray-400">Response within 24 hours</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="bg-green-100 p-3 rounded-full text-primary">
                                    <Phone size={24} />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-dark">Call Us</h3>
                                    <p className="text-gray-600">+923318689110 | +923155514161</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map Integration */}
                    <div className="bg-gray-200 rounded-xl overflow-hidden min-h-[400px] shadow-lg">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3616.697472654321!2d67.06644231500366!3d24.97636198399943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb340e584b89b43%3A0xc364b4d6aa123456!2sPlot%20A%2F6%2C%20Sector%2011-G%2C%20New%20Karachi%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1678901234567!5m2!1sen!2s"
                            width="100%"
                            height="100%"
                            style={{ border: 0, minHeight: '400px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Thread and Needle Valley Location"
                        ></iframe>
                    </div>
                </div>
            </div>
            <OrderCTA />
        </div>
    );
};

export default Contact;
